import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {toBackDateTime} from "../../common/util/util-dates";
import moment from "moment";
import {classNames} from "../../common/util/util-helpers";
import {FieldClearIcon} from "../../data/themes/icons";

export default function FieldDate({item = {}, onChange}) {

    if (!item.props) {
        item.props = {}
    }

    return (
        <div className='relative w-full'>
            <DatePicker
                selected={moment(item.value).isValid() ? moment(item.value).toDate() : null}
                onChange={(date) => {
                    onChange(item.name, !!date ? toBackDateTime(date) : "");
                }}
                minDate={item.props.minDate ? moment(item.props.minDate).toDate() : null}
                maxDate={item.props.maxDate ? moment(item.props.maxDate).toDate() : null}
                disabled={item.disabled}
                showTimeSelect={false} // make condition based on a type
                placeholderText={"__/__/__"} // make condition based on user settings
                timeFormat="h:mm aa"
                //dateFormat="MM/dd/yy h:mm aa" make condition based on a type
                dateFormat="MM/dd/yy"
                timeIntervals={15}
                timeCaption="time"
                popperPlacement={!!item.props.placement ? item.props.placement : "bottom-start"}
                popperProps={item.props.popperProps}
                className={classNames(
                    "form-control text-center relative",
                    !!item.props.addClass ? item.props.addClass : undefined,
                    item.errorMessage ? " is-invalid" : undefined
                )}
            />


            {item.props.isClearable && item.value && !item.disabled && (
                <button
                    tabIndex={item.props.isCloseFocusable === false ? "-1" : null}
                    onClick={() => onChange(item.name, "")}
                    className="absolute z-10 inset-y-0 right-0 px-3 flex items-center cursor-pointer hover:text-tm-gray-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-tint">
                    <FieldClearIcon/>
                </button>
            )}
        </div>
    )
}

